import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "../api/config"

const initialState = {
    isLoading: false,
    success: false,
    message: null,
    commissions: [],
    isSubmit: false,
    commission: {},
    successAction: false
}

// Thunk to get commissions with optional status filter
export const getCommissions = createAsyncThunk(
    'commissions/',
    async (values, thunkAPI) => {
        try {
            const status = values?.status || 'pending';
            const page = values?.page || 1;
            const limit = values?.limit || 10;
            
            const res = await request(`commissions?status=${status}&page=${page}&limit=${limit}`);
            if(res.code === 200) {
                return res;
            } else {
                return thunkAPI.rejectWithValue(res.message);
            }
        } catch (e) {
            return thunkAPI.rejectWithValue('Houve um erro ao retornar as comissões');
        }
    }
)

// Thunk to get details of a specific commission
export const getCommissionDetails = createAsyncThunk(
    'commissions/details',
    async (id, thunkAPI) => {
        try {
            const res = await request(`commissions/${id}`);
            if(res.code === 200) {
                return res.data;
            } else {
                return thunkAPI.rejectWithValue(res.message);
            }
        } catch (e) {
            return thunkAPI.rejectWithValue('Houve um erro ao obter detalhes da comissão');
        }
    }
)

// Thunk to approve a commission
export const approveCommission = createAsyncThunk(
    'commissions/approve',
    async (id, thunkAPI) => {
        try {
            const res = await request(`commissions/approve/${id}`, 'PUT');
            if(res.code === 200) {
                return res.data;
            } else {
                return thunkAPI.rejectWithValue(res.message);
            }
        } catch (e) {
            return thunkAPI.rejectWithValue('Houve um erro ao aprovar a comissão');
        }
    }
)

// Thunk to reject a commission
export const rejectCommission = createAsyncThunk(
    'commissions/reject',
    async ({id, rejectionReason}, thunkAPI) => {
        try {
            const body = rejectionReason ? { reason: rejectionReason } : {};
            const res = await request(`commissions/reject/${id}`, 'PUT', body);
            if(res.code === 200) {
                return res.data;
            } else {
                return thunkAPI.rejectWithValue(res.message);
            }
        } catch (e) {
            return thunkAPI.rejectWithValue('Houve um erro ao rejeitar a comissão');
        }
    }
)

// Thunk to generate commissions for a contract
export const generateCommissions = createAsyncThunk(
    'commissions/generate',
    async (contractId, thunkAPI) => {
        try {
            const res = await request('commissions/generate', 'POST', { contractId });
            if(res.success) {
                return res.commissions;
            } else {
                return thunkAPI.rejectWithValue(res.message);
            }
        } catch (e) {
            return thunkAPI.rejectWithValue('Houve um erro ao gerar comissões');
        }
    }
)

const commissionsSlice = createSlice({
    name: 'commissions',
    initialState,
    reducers: {
        resetSuccessAction: (state) => {
            state.successAction = false;
        },
        resetErrorMessage: (state) => {
            state.message = null;
        }
    },
    extraReducers(builder) {
        builder
            // getCommissions reducers
            .addCase(getCommissions.pending, (state) => {
                state.isLoading = true;
                state.message = null;
            })
            .addCase(getCommissions.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.success = true;
                state.message = null;
                state.commissions = payload.data;
                state.pagination = payload.pagination;
            })
            .addCase(getCommissions.rejected, (state, { payload }) => {
                state.isLoading = false;
                state.success = false;
                state.message = payload;
            })
            
            // getCommissionDetails reducers
            .addCase(getCommissionDetails.pending, (state) => {
                state.isLoading = true;
                state.message = null;
            })
            .addCase(getCommissionDetails.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.success = true;
                state.message = null;
                state.commission = payload;
            })
            .addCase(getCommissionDetails.rejected, (state, { payload }) => {
                state.isLoading = false;
                state.success = false;
                state.message = payload;
            })
            
            // approveCommission reducers
            .addCase(approveCommission.pending, (state) => {
                state.isSubmit = true;
                state.message = null;
            })
            .addCase(approveCommission.fulfilled, (state) => {
                state.isSubmit = false;
                state.successAction = true;
                state.message = null;
            })
            .addCase(approveCommission.rejected, (state, { payload }) => {
                state.isSubmit = false;
                state.successAction = false;
                state.message = payload;
            })
            
            // rejectCommission reducers
            .addCase(rejectCommission.pending, (state) => {
                state.isSubmit = true;
                state.message = null;
            })
            .addCase(rejectCommission.fulfilled, (state) => {
                state.isSubmit = false;
                state.successAction = true;
                state.message = null;
            })
            .addCase(rejectCommission.rejected, (state, { payload }) => {
                state.isSubmit = false;
                state.successAction = false;
                state.message = payload;
            })
            
            // generateCommissions reducers
            .addCase(generateCommissions.pending, (state) => {
                state.isSubmit = true;
                state.message = null;
            })
            .addCase(generateCommissions.fulfilled, (state) => {
                state.isSubmit = false;
                state.successAction = true;
                state.message = null;
            })
            .addCase(generateCommissions.rejected, (state, { payload }) => {
                state.isSubmit = false;
                state.successAction = false;
                state.message = payload;
            })
    }
})

export const { resetSuccessAction, resetErrorMessage } = commissionsSlice.actions;

export default commissionsSlice.reducer 